const TRANSIENT_TWC_XFLOW_MODAL_PARAMS = [
	'openTwcXflowModal',
	'cloudId',
	'source',
	'context',
] as const;

export const cleanupLaunchParams = (): void => {
	if (!globalThis.location || !globalThis.history) {
		return;
	}

	try {
		const url = new URL(globalThis.location.href);
		const shouldReplace = TRANSIENT_TWC_XFLOW_MODAL_PARAMS.some((param) =>
			url.searchParams.has(param),
		);
		if (!shouldReplace) {
			return;
		}

		TRANSIENT_TWC_XFLOW_MODAL_PARAMS.forEach((param) => url.searchParams.delete(param));
		globalThis.history.replaceState(globalThis.history.state, '', url.toString());
	} catch {}
};
